import { Button, Empty, Row, Space, Spin, Tooltip } from 'antd'
import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { LoadingOutlined } from '@ant-design/icons'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { GrFormAdd, GrFormSubtract } from 'react-icons/gr';

// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


export default function Sop() {
    const [ pageScale, setPageScale ] = useState(1);
    const [ pageNumber, setPageNumber ] = useState(null);
  return (
    <Row className='box-shadow bg-light justify-content-center round-edges px-3 py-2 mb-2 position-relative' style={{ height: 'calc( 100vh - 82px )'}}>
        <Document
            className='custom-pdf-viewer'
            file={'/pdf/SopHR.pdf'} 
            loading={<Spin size='large' indicator={<LoadingOutlined className='text-dark' />} spinning={true}/>}
            onLoadSuccess={({numPages}) => setPageNumber(numPages)} 
            noData={<Empty style={{transform: 'translateY(50vh - 50%)'}} />}
        >
            {Array.from(
                new Array(pageNumber),
                (el, index) => (
                <Page
                    className='my-3'
                    scale={pageScale}
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                />
                ),
            )}
        </Document>

        <Tooltip overlayInnerStyle={{color: 'black'}} title={`${Math.round(pageScale * 100)}%`} color='#ffffff' key='1'>
            <Space.Compact className='position-absolute top-0 end-0 p-2'>
                <Button onClick={() => setPageScale(pageScale>0.2 ? pageScale - 0.1 : 0.1)}><GrFormSubtract className='fs-5' /></Button>
                <Button onClick={() => setPageScale(pageScale + 0.1)}><GrFormAdd className='fs-5' /></Button>
            </Space.Compact>
        </Tooltip>
    </Row>
  )
}
